export default __webpack_public_path__ + "static/media/205948.b2b17e59.jpg";